import { useEffect, useRef, useState } from "react";
import * as theme from "../theme";
import "./EachFormNavTab.css";
import { isInViewport } from "./resusableFuncs";
import FormHeaderAndSubGroups from "../formnavigation/FormHeaderAndSubGroups";
import { useSelector } from "react-redux";
import { getIsFormAnyPriority, getFormText } from "../store/qf";

const EachFormNavTab = ({ formid, currentnode }) => {
  //   const text = useSelector(
  //     (state) => state.entities.qf.formstate[formid].text[languagecode]
  //   );

  // const dispatch = useDispatch();
  const thisFormRef = useRef(null);

  const isFormOpen = formid === currentnode?.formid;
  const isFormAnyPriority = useSelector(getIsFormAnyPriority({formid}))
  const text = useSelector(getFormText(formid));
  const [display, setDisplay] = useState("flex")
  useEffect(() => {
    if (isFormOpen) {
      if (thisFormRef.current && !isInViewport(thisFormRef.current)) {
        // queRef.current.scrollIntoView();
        thisFormRef.current.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center",
        });
      }
    }
  }, [isFormOpen]);

  useEffect(() => {
    if(!isFormAnyPriority){
      setDisplay("none")
    }
    else{
      setDisplay("flex")
    }
  }, [isFormAnyPriority])

  return (
    <div
      ref={thisFormRef}
      style={{
        display: display,
        cursor: "pointer",
        minHeight: theme.SCALES.qfNavTabHeaderHeight,
        borderBottom: `2px solid ${theme.COLORS.navigation_in_between_line_color}`,
      }}
      // onClick={() => {
      //   //change node to form's current node
      //   dispatch(currentNodeChangedOnDirectClick(formid));
      // }}
    >
      <FormHeaderAndSubGroups
        key={`form_${formid}`}
        formid={formid}
        currentnode={currentnode}
      ></FormHeaderAndSubGroups>
    </div>
  );
};

export default EachFormNavTab;
